import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { formatDate } from "@/lib/format";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const NotificationBell = () => {
  const { t, locale } = useI18n();
  const nav = useNavigate();
  const { data, refetch } = useQuery({ queryKey: ["notifications"], queryFn: async () => (await api.get("/notifications")).data, refetchInterval: 20000 });
  const count = (data?.unread || 0) + (data?.unread_messages || 0);
  const readAll = async () => { await api.post("/notifications/read-all"); refetch(); };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative rounded-full p-2 hover:bg-[#F1F4F9]" data-testid="notification-bell-btn" aria-label={t("p2.notif.title")}>
          <Bell className="h-5 w-5" />
          {count > 0 && <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-[#FF7A6B] px-1 text-[10px] font-bold text-white" data-testid="notification-count">{count}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 rounded-2xl p-0" data-testid="notification-panel">
        <div className="flex items-center justify-between border-b px-4 py-3"><p className="font-semibold">{t("p2.notif.title")}</p>
          <button onClick={readAll} className="text-xs font-semibold text-[#3B1272]" data-testid="notifications-read-all">{t("p2.notif.readAll")}</button></div>
        <div className="max-h-80 overflow-y-auto">
          {!data?.items?.length ? <p className="p-6 text-center text-sm text-[#64748B]">{t("p2.notif.empty")}</p> : data.items.map((n) => (
            <button key={n.notification_id} onClick={() => nav(n.link)} className={`block w-full border-b px-4 py-3 text-left text-sm hover:bg-[#F8F9FC] ${n.read ? "" : "bg-[#FBF9FF]"}`} data-testid="notification-item">
              <p className="font-semibold">{n.title}</p><p className="text-xs text-[#4B4763]">{n.body}</p><p className="mt-0.5 text-[10px] text-[#94A3B8]">{formatDate(n.created_at, locale, true)}</p>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
